export const supportCopy = {
  th: {
    title: "ศูนย์ช่วยเหลือ",
    subtitle: "พูดคุยเรื่องพื้นที่ของคุณ",
    conversations: "บทสนทนา",
    newChat: "เริ่มบทสนทนา",
    empty: "ยังไม่มีบทสนทนา",
    welcome: "เราช่วยอะไรคุณได้บ้าง?",
    welcomeBody:
      "ถามเรื่องการปรึกษา สำรวจหน้างาน BOQ หรือการติดตามโครงการได้ที่นี่",
    hours: "เจ้าหน้าที่ 09:00–18:00 น. · เวลาไทย",
    hoursBody:
      "นอกเวลาบริการ AI ช่วยตอบจากข้อมูลที่อนุมัติแล้ว เรื่องที่ต้องตรวจสอบจะส่งต่อเจ้าหน้าที่",
    ai: "กำลังคุยกับ AI",
    human: "กำลังคุยกับเจ้าหน้าที่",
    waiting: "รอเจ้าหน้าที่ตรวจสอบ",
    review: "AI ตอบแล้ว · รอเจ้าหน้าที่ตรวจสอบ",
    requestHuman: "ขอคุยกับเจ้าหน้าที่",
    placeholder: "พิมพ์ข้อความของคุณ…",
    send: "ส่ง",
    attach: "แนบไฟล์",
    back: "บทสนทนา",
    home: "กลับหน้าหลัก",
    login: "เข้าสู่ระบบเพื่อเริ่มสนทนา",
    loginBody:
      "ใช้บัญชี Decobaan เพื่อเก็บประวัติและไฟล์ของคุณอย่างเป็นส่วนตัว",
    error:
      "เชื่อมต่อไม่ได้ กรุณาลองอีกครั้ง ข้อความที่ส่งสำเร็จยังอยู่ในประวัติ",
    retry: "ลองอีกครั้ง",
    sending: "กำลังส่ง…",
    failed: "ยังไม่ส่ง · ลองอีกครั้ง",
    attachmentHelp: "JPG, PNG, PDF หรือ TXT · ไม่เกิน 10 MB · สูงสุด 5 ไฟล์",
    scan: "รอตรวจสอบไฟล์",
    remove: "นำไฟล์ออก",
    loading: "กำลังโหลดบทสนทนา…",
    saved: "ส่งและบันทึกแล้ว",
    note: "AI ให้ข้อมูลเบื้องต้น ไม่ยืนยันราคา สัญญา การจอง หรือการชำระเงินแทนเจ้าหน้าที่",
    more: "ดูบทสนทนาเพิ่มเติม",
    offline: "ออฟไลน์ · ข้อความยังไม่ได้ส่ง",
    you: "คุณ",
    agent: "ทีม Decobaan",
    aiName: "ผู้ช่วย AI",
    download: "ดาวน์โหลดไฟล์",
    humanSaved: "บันทึกคำขอเจ้าหน้าที่แล้ว จะตอบต่อในบทสนทนานี้",
    questions: [
      "เริ่มปรึกษาและสำรวจหน้างานอย่างไร?",
      "ราคาประเมินต่างจาก BOQ อย่างไร?",
      "ติดตามงานและแจ้งงานแก้ไขอย่างไร?",
    ],
    leave: "ยังมีข้อความหรือไฟล์ที่ไม่ได้ส่ง",
    close: "บทสนทนานี้ปิดแล้ว เริ่มบทสนทนาใหม่ได้",
    unavailable: "ยังไม่ได้เชื่อมต่อบริการลูกค้า กรุณาลองอีกครั้งภายหลัง",
    fileError: "ไฟล์ไม่ถูกต้องหรือส่งไม่สำเร็จ กรุณาตรวจชนิดและขนาดไฟล์",
  },
  ko: {
    title: "고객센터",
    subtitle: "공간에 관한 이야기를 나누세요",
    conversations: "대화 목록",
    newChat: "새 대화",
    empty: "아직 대화가 없습니다",
    welcome: "무엇을 도와드릴까요?",
    welcomeBody: "상담·실측·BOQ 견적·프로젝트 진행에 대해 문의하세요.",
    hours: "사람 상담 09:00–18:00 · 태국시간",
    hoursBody:
      "운영시간 외에는 AI가 승인된 자료로 안내합니다. 확인이 필요한 내용은 담당자에게 전달합니다.",
    ai: "AI 상담 중",
    human: "사람 상담 중",
    waiting: "담당자 확인 대기",
    review: "AI 해결 · 검토 대기",
    requestHuman: "사람 상담 요청",
    placeholder: "메시지를 입력하세요…",
    send: "보내기",
    attach: "파일 첨부",
    back: "대화 목록",
    home: "홈으로",
    login: "로그인하고 상담 시작",
    loginBody: "기존 Decobaan 계정으로 대화와 파일을 안전하게 보관하세요.",
    error:
      "연결하지 못했습니다. 다시 시도해 주세요. 전송 완료된 메시지는 보존됩니다.",
    retry: "다시 시도",
    sending: "전송 중…",
    failed: "미전송 · 다시 시도",
    attachmentHelp: "JPG·PNG·PDF·TXT · 파일당 최대 10 MB · 최대 5개",
    scan: "파일 검사 대기",
    remove: "첨부 제거",
    loading: "대화를 불러오고 있습니다…",
    saved: "전송·저장 완료",
    note: "AI는 참고 정보를 제공합니다. 가격·계약·예약·결제를 담당자 대신 확정하지 않습니다.",
    more: "대화 더 보기",
    offline: "오프라인 · 메시지가 아직 전송되지 않았습니다",
    you: "나",
    agent: "Decobaan 담당자",
    aiName: "AI 도우미",
    download: "첨부 다운로드",
    humanSaved:
      "사람 상담 요청을 접수했습니다. 같은 대화에서 답변을 이어갑니다.",
    questions: [
      "상담과 실측은 어떻게 시작하나요?",
      "예상 견적과 BOQ는 어떻게 다른가요?",
      "공정 확인과 하자 접수는 어떻게 하나요?",
    ],
    leave: "미전송 메시지나 첨부가 있습니다",
    close: "종료된 대화입니다. 새 대화를 시작할 수 있습니다.",
    unavailable:
      "고객센터 연결이 아직 설정되지 않았습니다. 잠시 후 다시 시도해 주세요.",
    fileError:
      "첨부가 유효하지 않거나 업로드하지 못했습니다. 형식과 크기를 확인해 주세요.",
  },
  en: {
    title: "Help center",
    subtitle: "Let's talk about your space",
    conversations: "Conversations",
    newChat: "New conversation",
    empty: "No conversations yet",
    welcome: "How can we help?",
    welcomeBody:
      "Ask about consultation, site surveys, BOQ quotes or your project.",
    hours: "Staff 09:00–18:00 · Bangkok time",
    hoursBody:
      "Outside staff hours, AI uses approved information. Questions needing confirmation are saved for staff.",
    ai: "Chatting with AI",
    human: "Chatting with staff",
    waiting: "Waiting for staff review",
    review: "AI answered · awaiting review",
    requestHuman: "Request a person",
    placeholder: "Write your message…",
    send: "Send",
    attach: "Attach file",
    back: "Conversations",
    home: "Back home",
    login: "Sign in to start chatting",
    loginBody:
      "Use your Decobaan account to keep conversations and attachments private.",
    error:
      "Could not connect. Try again. Successfully sent messages remain saved.",
    retry: "Try again",
    sending: "Sending…",
    failed: "Not sent · retry",
    attachmentHelp: "JPG, PNG, PDF or TXT · 10 MB each · up to 5 files",
    scan: "File scan pending",
    remove: "Remove attachment",
    loading: "Loading conversations…",
    saved: "Sent and saved",
    note: "AI provides information. It cannot confirm prices, contracts, bookings or payments for staff.",
    more: "Load more conversations",
    offline: "Offline · message not sent",
    you: "You",
    agent: "Decobaan team",
    aiName: "AI assistant",
    download: "Download attachment",
    humanSaved:
      "Your request is saved. Staff will continue in this conversation.",
    questions: [
      "How do I start consultation and a site survey?",
      "How does an estimate differ from a BOQ?",
      "How do I follow progress or report defects?",
    ],
    leave: "You have unsent messages or attachments",
    close: "This conversation is closed. You can start a new one.",
    unavailable:
      "Customer support has not been connected yet. Please try later.",
    fileError: "Invalid file or upload failed. Check file type and size.",
  },
};
